import { labelDefaultMediumStyles, labelDefaultRegularStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const ItemRow = styled.div<{ $hasBorder?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['04']};
  padding: ${({ $hasBorder = true, theme }) => ($hasBorder ? theme.size.space['04'] : 0)};
  border-radius: ${({ $hasBorder = true, theme }) => ($hasBorder ? theme.size.border.radius['04'] : 0)};
  border: ${({ $hasBorder = true, theme }) => ($hasBorder ? `1px solid ${theme.color.border.subtle}` : 'none')};
`

export const ItemIcon = styled.div<{ $isFile?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: ${({ theme }) => theme.size.space['03']};
  background: ${({ theme }) => theme.color.feedback.action.subtle};
  border-radius: ${({ theme }) => theme.size.border.radius['04']};

  svg {
    width: ${({ theme }) => theme.size.icon.medium};
    height: ${({ theme }) => theme.size.icon.medium};

    path {
      fill: ${({ $isFile = true, theme }) => ($isFile ? theme.color.feedback.action.default : 'none')};
      stroke: ${({ $isFile = true, theme }) => ($isFile ? 'none' : theme.color.feedback.action.default)};
    }
  }
`

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

export const ItemTitle = styled.div`
  ${labelDefaultMediumStyles}
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.color.content.main};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* PopoverForOverflownText measures its own text node; it must be width-constrained. */
  & > * {
    min-width: 0;
    max-width: 100%;
  }
`

export const ItemSubtitle = styled.div`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.secondary};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ItemActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['03']};
  flex-shrink: 0;

  svg {
    width: ${({ theme }) => theme.size.icon.small};
    height: ${({ theme }) => theme.size.icon.small};
    cursor: pointer;

    path {
      fill: ${({ theme }) => theme.color.content.secondary};
    }

    &:hover {
      opacity: 0.5;
    }
  }
`

export const IconButton = styled.span`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`
